import React from 'react';
import {Button, Form, Input, Modal, notification, Select, Typography} from "antd";
import ApiService from "../../../services/ApiService"
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;

export default class ModalEditFamille extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    state = {
        visible: false,
        loading: false,
        id: null,
        edit: false,
        defaultData: {},
    };

    async show(data = null) {
        if (data) {
            var newData = {...data}
            this.setState({visible: true, id: newData.id, defaultData: newData, edit: true})
        } else {
            this.setState({visible: true})
        }
    }

    onSearch = (text) => {
        this.setState({text});
    }

    close() {
        this.setState({
            visible: false,
            loading: false,
            id: null,
            edit: false,
            defaultData: {},
        })
    }

    async onSubmit(data) {
        if (this.state.edit && !this.state.id) {
            notification.error({
                message: t`Erreur lors de l'édition`
            })
            this.close()
            return false
        }

        if (this.state.edit) {
            data.id = this.state.id
        }

        var res = await ApiService.post("/contact/familles/edit", data)

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Édition réussie` : t`Ajout réussi`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de l'édition` : t`Erreur lors de l'ajout`
            })
        }
    }

    render() {
        return (
            <Modal width="100%" title={this.state.edit ? t`Éditer une Famille` : t`Ajouter une Famille`}
                   open={this.state.visible} destroyOnClose closable footer={null} onCancel={() => this.close()}>

                <Form
                    initialValues={this.state.defaultData}
                    onFinish={(data) => this.onSubmit(data)}
                >

                    <Form.Item
                        label={t`Nom de la Famille`}
                        name="name"
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    >
                        <Input placeholder={t`Bénichou | Marciano | Marciano 2 Etc.`}/>
                    </Form.Item>

                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>

                </Form>
            </Modal>
        )
    }
}
